import React from 'react'; 
import {Row, Col, Label, Button, FormGroup,
         FormControl, ControlLabel, ButtonToolbar} from 'react-bootstrap';
import {injectIntl} from 'react-intl';
import {inject, observer} from 'mobx-react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';


@injectIntl @inject("rootStore") @observer
export default class ActivityInformationForm extends React.Component{

  constructor(props){
    super(props);

    this.handlePlaceChange = this.handlePlaceChange.bind(this);
    this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleFinishDateChange = this.handleFinishDateChange.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);

  }

  render(){
    let activityEdit = this.props.rootStore.activityStore.activityEdit;
    const {intl} = this.props;
    return(
      <div>
        <Row>
          <Col xs={12}>
            <span className="bold">{intl.formatMessage({id: "additional_information"})}</span><br /><br />
            <FormGroup
              controlId="specific_name"
              >
              <Row>
                <Col xs={12} md={3}>
                  <ControlLabel>{intl.formatMessage({id: "specific_name"})}</ControlLabel>
                </Col>
                <Col xs={12} md={9}>
                  <FormControl className="subject" value={activityEdit.name}
                    onChange={this.handleNameChange} type="text" />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup
              controlId="place"
              >
                <Row>
                  <Col xs={12} md={3}>
                    <ControlLabel>{intl.formatMessage({id: "location"})}</ControlLabel>
                  </Col>
                  <Col xs={12} md={9}>
                    <FormControl className="subject" value={activityEdit.place}
                      onChange={this.handlePlaceChange} type="text" />
                  </Col>
                </Row>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <FormGroup controlId="startDate" 
              validationState={activityEdit.validateDates()}>
              <Row>
                <Col xs={12} md={3}>
                  <ControlLabel>{intl.formatMessage({id: "start_date"})}</ControlLabel>
                </Col>
                <Col xs={12} md={9}>
                  <DatePicker
                    selected={activityEdit.startDate}
                    onChange={this.handleStartDateChange}
                    showTimeSelect
                    dateFormat="LLL"
                    className="form-control"
                    readOnly={true}
                    locale={intl.locale}
                  />
                </Col>
              </Row>
            </FormGroup>
          </Col>
          <Col xs={12}>
            <FormGroup controlId="finishDate"
             validationState={activityEdit.validateDates()}>
              <Row>
                <Col xs={12} md={3}>
                  <ControlLabel>{intl.formatMessage({id: "finish_date"})}</ControlLabel>
                </Col>
                <Col xs={12} md={9}>
                <DatePicker
                  selected={activityEdit.finishDate}
                  onChange={this.handleFinishDateChange}
                  showTimeSelect
                  dateFormat="LLL"
                  className="form-control"
                  readOnly={true}
                  locale={intl.locale}
                />
                </Col>
              </Row>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <FormGroup
              controlId="description"
              >
              <Row>
                <Col xs={12} md={3}>
                  <ControlLabel>{intl.formatMessage({id: "description"})}</ControlLabel>
                </Col>
                <Col xs={12} md={9}>
                  <FormControl componentClass="textarea" rows={3} className="subject" value={activityEdit.description}
                    onChange={this.handleDescriptionChange} type="text" />
                </Col>
              </Row>
            </FormGroup>
          </Col>
        </Row>
      </div>
    );
  }

  handlePlaceChange(e){
    this.props.rootStore.activityStore.activityEdit.handlePlaceChange(e.target.value);
  }

  handleStartDateChange(date){
    this.props.rootStore.activityStore.activityEdit.handleStartDateChange(date);
  }

  handleFinishDateChange(date){
    this.props.rootStore.activityStore.activityEdit.handleFinishDateChange(date);
  }

  handleDescriptionChange(e){
    this.props.rootStore.activityStore.activityEdit.handleDescriptionChange(e.target.value);
  }

  handleNameChange(e){
    this.props.rootStore.activityStore.activityEdit.handleNameChange(e.target.value);
  }

}

